export default "__VITE_ASSET__C5XiN9Ok__"